/* 平台下单 */
<template>
    <div id="sureForm">

        <div class="sureForm-header" @click="$router.back()"><img src="@/assets/img/back.jpg" /> 返回</div>

        <el-form :model="form" :rules="rules" ref="form" label-width="100%" label-position="left">


            <div class="sureForm-title">
                <h3>订单信息</h3>
            </div>
            <!-- 禁用今天之前的日期 -->
            <el-form-item label="用车时间" prop="">
                <el-form-item label="" prop="orderTime" style="width: 49%; display: inline-block;">
                    <el-date-picker v-model="form.orderTime" format="yyyy-MM-dd" type="date" placeholder="请选择用车日期"
                        :picker-options="pickerOptions" />
                </el-form-item>
                <el-form-item label="" prop="orderDate" style="width: 49%;margin-left: 8px; display: inline-block;">
                    <!-- <el-time-picker v-model="form.orderDate" format="HH:mm"
                        placeholder="请选择用车时间" /> -->
                    <el-time-select placeholder="请选择用车时间" v-model="form.orderDate" :picker-options="{
                        start: '00:00',
                        step: '00:15',
                        end: '23:45'
                    }">
                    </el-time-select>
                </el-form-item>
            </el-form-item>


            <el-form-item label="上车位置" prop="startAddress">
                <span style="font-size: 14px"
                    v-if="startStationRail.length == 1 && startStationRail[0].stationType == 1">{{
                        startAddress }}</span>
                <el-button v-else @click="changeAddress(1)" type="text">
                    {{ startAddress ? startAddress : "点击选择" }}
                </el-button>
            </el-form-item>

            <el-form-item label="下车位置" prop="endAddress">
                <span style="font-size: 14px" v-if="endStationRail.length == 1 && endStationRail[0].stationType == 1">{{
                    endAddress }}</span>
                <el-button v-else @click="changeAddress(2)" type="text">
                    {{ endAddress ? endAddress : "点击选择" }}
                </el-button>
            </el-form-item>

            <el-form-item>
                <el-checkbox v-model="form.needTransfer">接送站服务</el-checkbox>
                <div class="tip-text">勾选后该订单即需填写航班/班次号</div>
            </el-form-item>

            <div class="traffic-row" v-if="form.needTransfer">
                <el-form-item label="交通方式" class="traffic-type" label-width="100%" prop="trafficType">
                    <el-radio-group v-model="form.trafficType" style="width: 100%;">
                        <el-radio-button label="航班"></el-radio-button>
                        <el-radio-button label="列车"></el-radio-button>
                        <el-radio-button label="汽车"></el-radio-button>
                    </el-radio-group>
                </el-form-item>

                <el-form-item label="航班/班次号" label-width="120px" class="traffic-no" prop="trafficNo">
                    <el-input placeholder="请输入" :maxlength="10" :value="form.trafficNo"
                        @input="trafficInput"></el-input>
                </el-form-item>
            </div>

            <el-form-item label="备注">
                <el-input type="textarea" v-model="form.remark" placeholder="请输入100字内的备注" :maxlength="100"
                    show-word-limit :rows="4"></el-input>
            </el-form-item>

        </el-form>

        <div class="sureForm-footer">
            <el-button size="medium" @click="$router.back()" :loading="loading">取消</el-button>
            <el-button size="medium" type="primary" @click="saveClick" :loading="loading">确定</el-button>
        </div>


        <chooseMap v-if="mapVisible" :visible.sync="mapVisible" :address.sync="mapAddress" :type="mapType"
            :startStationRail="startStationRail" :endStationRail="endStationRail" :startId.sync="startId"
            :endId.sync="endId" @confirm="mapConfirm" />
    </div>
</template>

<script>
import chooseMap from "./chooseMap.vue";

export default {
    components: { chooseMap },
    name: "sureForm",
    props: {
        copyPhone: {
            default() {
                return null;
            },
        },
    },
    data() {
        return {
            travelLineId: this.$route.query.travelLineId,
            orderId: this.$route.query.orderId,
            stationList: [],
            startStationRail: [],
            endStationRail: [],
            startId: null,
            endId: null,

            mapVisible: false,
            mapType: 1,
            mapAddress: {},
            // 表单
            form: {
                orderTime: '',
                orderDate: '',
                address: [{ type: 1 }, { type: 2 }],
                needTransfer: false,
                trafficType: '',
                trafficNo: '',
                remark: ''
            },
            // 校验规则
            rules: {
                orderTime: [
                    {
                        required: true,
                        message: "请选择用车日期",
                        trigger: ["blur", "change"],
                    },
                ],
                orderDate: [
                    {
                        required: true,
                        message: "请选择用车时间",
                        trigger: ["blur", "change"],
                    },
                ],
                startAddress: [
                    {
                        required: true,
                        message: "请选择上车位置",
                        trigger: ["blur", "change"],
                    },
                ],
                endAddress: [
                    {
                        required: true,
                        message: "请选择下车位置",
                        trigger: ["blur", "change"],
                    },
                ],
                trafficType: [
                    {
                        required: true,
                        message: "请选择交通方式",
                        trigger: ["blur", "change"],
                        validator: (rule, value, callback) => {
                            if (this.form.needTransfer && !value) {
                                callback(new Error("请选择交通方式"));
                            } else {
                                callback();
                            }
                        }
                    },
                ],
                trafficNo: [
                    {
                        required: true,
                        message: "请输入航班/班次号",
                        trigger: ["blur", "change"],
                        validator: (rule, value, callback) => {
                            if (this.form.needTransfer && !value) {
                                callback(new Error("请输入航班/班次号"));
                            } else {
                                callback();
                            }
                        }
                    },
                ],
            },
            loading: false,
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 86400000; // 禁用今天之前的日期
                }
            },
        };
    },
    computed: {
        /* 是否显示地图上围栏相关的操作按钮 */
        startAddress() {
            let item = this.form.address.find((item) => item.type == 1);
            let name = item.name;
            this.$set(this.form, "startAddress", name);
            return name;
        },
        endAddress() {
            let item = this.form.address.find((item) => item.type == 2);
            let name = item.name;
            this.$set(this.form, "endAddress", name);
            return name;
        }
    },
    watch: {
        'form.needTransfer'(newVal) {
            if (!newVal) {
                // 取消勾选时重置交通方式和班次号
                this.form.trafficType = '';
                this.form.trafficNo = '';
            }
        }
    },
    created() {
        this.getStationList();
        if (this.$route.query.type == 'update') {
            this.getDetail();
        } else {
            this.form.orderTime = this.$route.query.orderDate * 1000;
            this.form.remark = this.$route.query.remark;
        }
    },
    methods: {
        trafficInput(value) {
            if (this.form.trafficType == '列车' || this.form.trafficType == '航班') {
                value = value.replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
            } else {
                value = value.replace(/[^a-zA-Z0-9.\u4e00-\u9fa5]/g, '').toUpperCase();
            }
            this.form.trafficNo = value
        },
        async getDetail() {
            let url = "/api/v1/manage/travelOrder/order/detail";
            let { code, data } = await this.$axios.get(url, {
                orderId: this.orderId
            });
            if (code == 1) {
                this.form.orderTime = data.orderTime * 1000;
                this.form.orderDate = this.$utils.timeFn(data.orderTime, 'HH:mm');
                this.form.needTransfer = data.trafficType && data.trafficNo ? true : false;
                this.form.trafficType = data.trafficType || '';
                this.form.trafficNo = data.trafficNo || '';
                this.form.remark = data.remark;
                this.form.address = [
                    {
                        type: 1,
                        name: data.startPointName,
                        longitude: data.startPointLng,
                        latitude: data.startPointLat,
                    },
                    {
                        type: 2,
                        name: data.endPointName,
                        longitude: data.endPointLng,
                        latitude: data.endPointLat,
                    }
                ]
            }
        },
        /* 获取站点信息 */
        async getStationList() {
            let url = "/api/v1/manage/travelOrder/line/station";
            let { code, data } = await this.$axios.get(url, {
                travelLineId: this.travelLineId
            });
            if (code == 1) {
                this.stationList = data;
                this.startStationRail = data.filter(item => item.type == 1);
                this.endStationRail = data.filter(item => item.type == 2);
                this.startId = this.startStationRail[0].id;
                this.endId = this.endStationRail[0].id;
                if (this.startStationRail.length == 1 && this.startStationRail[0].stationType == 1) {
                    let obj = {
                        type: 1,
                        stationType: this.startStationRail[0].stationType,
                        city: this.startStationRail[0].city,
                        longitude: this.startStationRail[0].longitude,
                        latitude: this.startStationRail[0].latitude,
                        name: this.startStationRail[0].stationName,
                        address: this.startStationRail[0].stationAddress,
                    };
                    this.$set(this.form, "startAddress", obj);
                    this.$set(this.form.address, 0, obj);
                }
                if (this.endStationRail.length === 1 && this.endStationRail[0].stationType == 1) {
                    let obj = {
                        type: 2,
                        stationType: this.endStationRail[0].stationType,
                        city: this.endStationRail[0].city,
                        longitude: this.endStationRail[0].longitude,
                        latitude: this.endStationRail[0].latitude,
                        name: this.endStationRail[0].stationName,
                        address: this.endStationRail[0].stationAddress,
                    };
                    this.$set(this.form, "endAddress", obj);
                    this.$set(this.form.address, 1, obj);
                }

            }
        },
        changeAddress(mapType) {
            this.mapType = mapType;
            this.mapVisible = true;
            this.mapAddress = this.form.address
                ? this.form.address.find((item) => item.type == mapType)
                : {};
        },



        mapConfirm(obj) {
            this.form.address = this.form.address.map((item) => {
                if (item.type == this.mapType) {
                    item = obj;
                }
                return item;
            });

            this.$set(this.form, this.mapType == 1 ? "startAddress" : "endAddress", obj);
            this.$refs.form.validateField(this.mapType == 1 ? "startAddress" : "endAddress");

        },

        /* 点击保存 */
        saveClick() {
            console.log('form.orderDate',this.form.orderDate)
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    let time = `${this.$utils.timeFn(this.form.orderTime, 'YYYY-MM-DD')} ${this.form.orderDate}`
                    let timeStamp = new Date(time).getTime() / 1000

                    let params = {
                        orderId: this.orderId,
                        orderTime: timeStamp,
                        startPointName: this.form.address[0].name,
                        endPointName: this.form.address[1].name,
                        startPointLng: this.form.address[0].longitude,
                        startPointLat: this.form.address[0].latitude,
                        endPointLng: this.form.address[1].longitude,
                        endPointLat: this.form.address[1].latitude,
                        trafficType: this.form.trafficType,
                        trafficNo: this.form.trafficNo,
                        remark: this.form.remark,
                    }
                    this.postFn(params);
                }
            });
        },

        /* 接口请求-提交 */
        async postFn(params) {
            this.loading = true;
            let url = "/api/v1/manage/travelOrder/order/confirm"
            let { code } = await this.$axios.post(url, params)
            if (code === 1) {
                this.$message.success("确认成功")
                this.$router.back()
            }
            this.loading = false;
        }
    }
};
</script>

<style lang="less">
#sureForm {
    height: calc(100% - 48px);
    padding-bottom: 50px;
    box-sizing: border-box;
    color: black;
    display: flex;
    flex-flow: column;
    align-items: center;
    overflow-y: scroll;

    &>* {
        width: 500px;
        margin-top: 20px;
        padding: 20px;
        border-radius: 20px;
        background-color: white;
    }

    .sureForm-header {
        font-size: 20px;
        font-weight: bold;
        cursor: pointer;
        display: flex;
        align-items: center;

        img {
            width: 20px;
            height: 20px;
            margin-right: 5px;
        }

        &:hover {
            color: #666;
        }
    }

    .sureForm-footer {
        text-align: right;
    }

    .sureForm-title {
        margin-bottom: 20px;
    }

    .customersTable {
        .el-table__row .el-table__cell {
            padding: 0;

            .cell {
                height: 60px;
                line-height: 60px;
            }
        }
    }

    .checkItem {
        height: 60px !important;
        margin-bottom: 0 !important;

        .el-form-item__content {
            line-height: 58px;
        }

        .el-form-item__error {
            top: unset;
            bottom: 0 !important;
        }
    }

    .el-form-item__content {
        margin-left: 0 !important;
    }

    .el-radio__label {
        display: none;
    }

    .time {
        width: 100%;
        overflow: hidden;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-column-gap: 10px;
    }

    .add {
        width: 100%;
        padding: 10px;
        margin-top: 20px;
        border: 1px #dcdfe6 dashed;
    }

    .traffic-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .traffic-type {
        flex: 1;
    }

    .traffic-no {
        flex: 1;
    }

    .el-radio-button {
        width: 32.4%;
    }

    .el-radio-button__inner {
        width: 100%;
    }

    .tip-text {
        font-size: 12px;
        color: #999;
        margin-left: 24px;
    }
}
</style>
